import React from 'react'
import {Locale} from '../../config/constants'
import {useLocale} from '../hocs/hooks'

const Word = ({children}) => {
  const locale = useLocale()
  return locale === Locale.ja
    ? <div className="d-inline-block text-nowrap">
      {children}
    </div>
    : <div className="d-inline-block text-nowrap mr-1">
      {children}
    </div>
}
Word.displayName = 'Word'
export default Word
